import { useRouter } from "next/router";
import { useUser } from "../../../hooks/useUser";
import { Container } from "../../Container/Container"
import ShowMoreText from "react-show-more-text";

export const ProfileDescription = () => {
    const router = useRouter();
    const { isLoading, data } = useUser(router.query.username as string);
    
    return <Container className="my-1 whitespace-pre-line px-[21px] py-[18px]" topL={false} topR={false} bottomL={false} bottomR={false}>
        {data?.description}
    </Container>
}